import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { AuthShell } from "../components/AuthShell";
import { resetPassword, formatApiError } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState(token ? "" : "This reset link is missing its code. Please request a new one.");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("The passwords don't match");
    setBusy(true);
    setError("");
    try {
      await resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <AuthShell title="Choose a new password" subtitle="Use at least 6 characters.">
      {done ? (
        <div data-testid="reset-success" className="space-y-4">
          <p className="flex gap-2 items-center text-slate-300"><CheckCircle2 size={18} className="text-[#D4FF3A]" /> Your password has been changed.</p>
          <Link to="/login" data-testid="reset-login-btn" className="what-btn-primary w-full !py-3">Log in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" className="what-input" />
          <input data-testid="reset-confirm-input" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat new password" className="what-input" />
          {error && <p data-testid="reset-error" className="text-sm text-red-400">{error}</p>}
          <button data-testid="reset-submit-btn" disabled={busy || !token} className="what-btn-primary w-full !py-3">
            {busy && <Loader2 size={16} className="animate-spin" />} Save new password
          </button>
          {error && <Link to="/forgot-password" data-testid="reset-request-new-link" className="block text-sm text-slate-400 hover:text-white">Request a new link</Link>}
        </form>
      )}
    </AuthShell>
  );
}
